import React from 'react';
import { Route, Switch, NavLink, Redirect} from 'react-router-dom';
import { EmailIcon , UserIcon} from 'components/vectors';
import ProfileSettings from '../ProfileSettings';
import EmailSettings from '../EmailSettings';


const ProfilePage = (props) => (
    <div className="row profile">

        <div className="col-md-3">
            <ul className="profile-side-menu">
                <NavLink to={`${props.match.url}/profile`} activeClassName="active" exact={true}> <li className="profile-side-menu__item"><UserIcon /> Profile</li> </NavLink>
                <NavLink to={`${props.match.url}/profile/email`} activeClassName="active"> <li className="profile-side-menu__item"> <EmailIcon /> Email Settings</li> </NavLink>
            </ul>
        </div>
        <div className="col-md-9">
            <div className="profile-main">
                <Switch>
                    <Route path={`${props.match.url}/profile`} component={ProfileSettings} exact/>
                    <Route path={`${props.match.url}/profile/email`} component={EmailSettings} exact/>
                    <Redirect to={{pathname: '/404'}}/>
                </Switch>
                
            </div>
        </div>

    </div>
)

export default ProfilePage;